import React, { useEffect, useRef, useState } from 'react';
import { Modal, Switch, theme } from 'antd';
import useInstantSave from './useInstantSave';

export default function SettingsSwitchStrip({ label, description, checked, onSave, confirm, disabled = false }) {
  const { token } = theme.useToken();
  const [modal, holder] = Modal.useModal();
  const instant = useInstantSave();
  const confirmation = useRef(null), flight = useRef(false), alive = useRef(true);
  const [asking, setAsking] = useState(false);
  useEffect(() => {
    alive.current = true;
    return () => { alive.current = false; confirmation.current?.destroy(); confirmation.current?.cancel(); };
  }, []);
  const change = async next => {
    if (disabled || flight.current) return;
    flight.current = true;
    try {
      const options = typeof confirm === 'function' ? confirm(next) : confirm;
      if (options) {
        setAsking(true);
        const accepted = await new Promise(resolve => {
          const dialog = modal.confirm({ ...options, onOk: () => resolve(true), onCancel: () => resolve(false) });
          confirmation.current = { destroy: dialog.destroy, cancel: () => resolve(false) };
        });
        confirmation.current = null;
        if (!alive.current || !accepted) return;
      }
      if (alive.current) await instant.save('enabled', next, onSave);
    } finally { flight.current = false; if (alive.current) setAsking(false); }
  };
  return <section data-testid="settings-switch-strip" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '10px 12px', marginBottom: 12, border: `1px solid ${token.colorBorderSecondary}`, borderRadius: 6, background: token.colorBgElevated, color: token.colorText }}>
    {holder}<div><div style={{ fontWeight: 600 }}>{label}</div>{description && <div style={{ fontSize: 12, color: token.colorTextSecondary }}>{description}</div>}</div>
    <Switch aria-label={label} checked={Boolean(checked)} disabled={disabled || asking || instant.saving('enabled')} loading={instant.saving('enabled')} onChange={change} />
  </section>;
}
